import { isRouteErrorResponse, useRouteError } from "react-router";
import { Button } from "qw-ui-lib-v2";

export function PageError() {
  const error = useRouteError();

  if (!isRouteErrorResponse(error)) {
    throw error;
  }

  return (
    <div className="page-error">
      <h1 className="page-error__title">Something Went Wrong</h1>
      <p className="page-error__message">An unexpected error occurred. Please try again.</p>
      <Button
        variant="primary"
        onPress={() => {
          window.location.href = "/";
          return;
        }}
      >
        Go Home
      </Button>
    </div>
  );
}
